export default __webpack_public_path__ + "assets/icons/home_mashangjijian.a0bdabb7.svg";